import React from 'react'
import { Grid } from '@material-ui/core'
import { Field } from '@progress/kendo-react-form'
import { Placeholder, Headline, StyledPaper, InnerGrid, SafeTextArea, FullsizedTextInput, FullsizedField } from '../styled/FormComponents'
import {
    getMediaFormatFoldedOptions,
    getMediaFormatUnFoldedOptions,
    getPaperContentTypeOptions,
    getPaperEnvelopeTypeOptions
} from '../../services'
import { ComboBoxField } from '../index'

export default ({ spaceBetweenGrids }) => {
    const paperEnvelopeTypes = getPaperEnvelopeTypeOptions()
    const paperContentTypes = getPaperContentTypeOptions()
    const mediaFoldedFormats = getMediaFormatFoldedOptions()
    const mediaUnFoldedFormats = getMediaFormatUnFoldedOptions()

    return <Grid container spacing={spaceBetweenGrids}>
        <InnerGrid item md={6}>
            <StyledPaper>
                <Headline>Papier Umschlag</Headline>
                <Grid container spacing={spaceBetweenGrids}>
                    <InnerGrid item md={6}>
                        <FullsizedField name="project.paperEnvelopePages" component={FullsizedTextInput} label="Seiten"/>
                    </InnerGrid>
                    <InnerGrid item md={6}>
                        <Field name="project.paperEnvelopeType" component={ComboBoxField} label="Papiersorte"
                               data={paperEnvelopeTypes} allowCustom suggest filterable width="100%"/>
                    </InnerGrid>
                </Grid>
            </StyledPaper>
            <StyledPaper>
                <Headline>Rund ums Medium</Headline>
                <Grid container spacing={spaceBetweenGrids}>
                    <InnerGrid item md={6}>
                        <Field name="project.mediaFormatFolded" component={ComboBoxField} label="Format gefalzt"
                               data={mediaFoldedFormats} allowCustom suggest filterable width="100%"/>
                        <FullsizedField name="project.mediaColor" component={FullsizedTextInput} label="Farbe"/>
                    </InnerGrid>
                    <InnerGrid item md={6}>
                        <Field name="project.mediaFormatUnFolded" component={ComboBoxField} label="Format offen"
                               data={mediaUnFoldedFormats} allowCustom suggest filterable width="100%"/>
                        <FullsizedField name="project.mediaPrePrint" component={FullsizedTextInput} label="Druckvorstufe"/>
                    </InnerGrid>
                </Grid>
                <Placeholder />
                <Field component={SafeTextArea} multiline rows={3} id="mediaProcessing" name="project.mediaProcessing"
                           variant="outlined"
                           fullWidth
                           label="Verarbeitung"/>
            </StyledPaper>
        </InnerGrid>
        <InnerGrid item md={6}>
            <StyledPaper>
                <Headline>Papier Inhalt</Headline>
                <Grid container spacing={spaceBetweenGrids}>
                    <InnerGrid item md={6}>
                        <FullsizedField name="project.paperContentPages" component={FullsizedTextInput} label="Seiten"/>
                    </InnerGrid>
                    <InnerGrid item md={6}>
                        <Field name="project.paperContentType" component={ComboBoxField} label="Papiersorte"
                               data={paperContentTypes} allowCustom suggest filterable width="100%"/>
                    </InnerGrid>
                </Grid>
            </StyledPaper>
            <StyledPaper>
                <Headline>Auflagenhöhe</Headline>
                <Grid container spacing={spaceBetweenGrids}>
                    <InnerGrid item md={6}>
                        <FullsizedField name="project.mediaAmountNeeded" component={FullsizedTextInput} label="Stück Anforderung"/>
                    </InnerGrid>
                    <InnerGrid item md={6}>
                        <FullsizedField name="project.mediaAmountRequested" component={FullsizedTextInput} label="Stück Anfrage"/>
                    </InnerGrid>
                </Grid>
            </StyledPaper>
            <StyledPaper>
                <Placeholder height="14px" />
                <Field component={SafeTextArea} multiline rows={4} name="project.remarks"
                           variant="outlined"
                           fullWidth
                           label="Anmerkungen / Besonderheiten"/>
            </StyledPaper>
        </InnerGrid>
    </Grid>
}



// WEBPACK FOOTER //
// ./src/components/dialog/PrintDataForm.js